import { SPONSORS } from "@/sponsor";

export function SponsorStrip() {
  if (SPONSORS.length === 0) return null;
  return (
    <section className="py-8 px-6 md:px-8 bg-white border-b border-[#e2e8f0]" data-testid="sponsor-strip">
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-14">
        <span className="text-base md:text-lg font-ui font-bold text-[#0f172a] uppercase tracking-widest">
          Main Sponsor
        </span>
        {SPONSORS.map((s, i) =>
          s.link ? (
            <a key={i} href={s.link} target="_blank" rel="noopener noreferrer" data-testid={`sponsor-${i}`} className="hover:opacity-80 transition-opacity">
              <img src={s.img} alt={s.name} className={`${s.h || "h-16 md:h-20"} w-auto object-contain`} />
            </a>
          ) : (
            <img key={i} src={s.img} alt={s.name} data-testid={`sponsor-${i}`} className={`${s.h || "h-16 md:h-20"} w-auto object-contain`} />
          )
        )}
      </div>
    </section>
  );
}
